import { Route, Routes } from 'react-router-dom'
import PeriodPage from './Page'
import { useSession } from 'components/Providers';
import NoAccess from 'components/NoAccess';

export default function Period() {
  const { permissions } = useSession();
  if (!permissions['setting.period']) return <NoAccess />

  return (
    <Routes>
      <Route path="/" element={<PeriodPage />} />
      <Route path="/:id" element={<PeriodPage />} />
    </Routes>
  )
}
